module.exports = __webpack_public_path__ + "img/Schmidt2025.1cb9f964.jpg";